var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"faqs-button-slider"},[_c('faqs-slider',{attrs:{"show":_vm.show},on:{"ActionOne":function($event){_vm.show = true},"ActionTwo":function($event){_vm.show = false}}})],1),_vm._v(" "),_c('div',{staticClass:"faqs-grid"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('shipping-card'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }